import React from "react";
import { Helmet } from "react-helmet";

import { Payments } from "features/Payments";
import { PageTitle } from "shared/ui/PageTitle";

const PaymentsPage = () => (
    <>
        <Helmet title="Платежи" />
        <PageTitle>Платежи</PageTitle>
        <Payments />
    </>
);

export default PaymentsPage;
